<template>
  <div :id="this.id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="CounterBarComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="parseInt(internal_config.height)"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">

      <sync-drag :target="this"/>

      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config"/>

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-CounterBarComponent'></options-element-bar>

      <div class="progress"
           v-bind:style="{height : height,width : width,border : border,'border-radius': radius,background: background,'box-shadow': boxShadow,}">
        <div class="progress-bar" ref="obj" role="progressbar" aria-valuenow="75" aria-valuemin="0"
             aria-valuemax="100" :style="{backgroundColor:internal_config.backgroundColorBar}"></div>
      </div>

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>

  import Data from './Model';
  import Resources from './Resources.vue';
  import OptionsElementBar from "../OptionsElementBar";
  import MixinComponents from "../../../../js/mixins/MixinComponents";

  export default {
    name: 'CounterBarComponent',
    props: ['config', 'id', 'preview'],
    mixins: [MixinComponents],
    components: {
      OptionsElementBar,
      Resources,
    },
    computed: {
      background() {
        let bg = this.internal_config.backgroundColor;

        if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
          bg += ' url("' + this.internal_config.backgroundImage + '")';
          bg += ' ' + this.internal_config.backgroundPosition;
          bg += ' / ' + this.internal_config.backgroundSize;
          bg += ' ' + this.internal_config.backgroundRepeat;
          bg += ' ' + this.internal_config.backgroundOrigin;
        }

        return bg;
      }
    },

    data() {
      return Data.data();
    },

    watch: {
      'internal_config': {
        deep: true,
        handler(value) {
          this.$eventHub.setValueElementConfig(this.id, value);
          this.$eventPointer.log(this.id, value);
        }
      },
    },

    methods: {

      onResize: function (x, y, width, height) {
        this.internal_config.width = width + 'px';
        this.internal_config.height = height + 'px';

        this.$refs.resourcesData.setValuesData(this);
      },

      showResources() {
        return this.$refs.resourcesData.getValuesData();
      },

      build(config) {
        this.internal_config = config;
      },

      rebuild() {
        let vm = this;
        let config = this.internal_config;
        this.internal_config = {};
        this.$nextTick(() => {
          vm.internal_config = config;
        });
      },

      textStyle() {
        return ` width: ${this.internal_config.width};
                       height: ${this.internal_config.height};
                       font-family: ${this.internal_config.textStyle.family};
                       font-size: ${this.internal_config.textStyle.size};
                       text-align: ${this.internal_config.textStyle.align};
                       font-weight: ${this.internal_config.textStyle.weight};
                       font-style: ${this.internal_config.textStyle.style};
                       text-decoration: ${this.internal_config.textStyle.stroke};
                       color: ${this.internal_config.textStyle.color}`;
      },

      style() {
        return `left:  ${this.internal_config.left};
                      padding-top: ${this.internal_config.paddingTop};
                      padding-left: ${this.internal_config.paddingLeft};
                      z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                      padding-right: ${this.internal_config.paddingRight};
                      padding-bottom: ${this.internal_config.paddingBottom};
                      top: ${this.internal_config.top}`;
      },

      styleResize() {
        return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
      },

      animateValue(obj, start, end, duration) {
        var range = end - start;
        var current = start;
        var increment = end > start ? 1 : -1;
        var stepTime = Math.abs(Math.floor(duration / range));
        var timer = setInterval(function () {
          current += increment;
          obj.style.width = parseInt(current) + '%';
          if (current == end) {
            clearInterval(timer);
          }
        }, stepTime);
      },
    },

    created() {
      this.build(this.$props.config);

      this.internal_config = window.mergeRecursive(this.props, this.$props.config);
    },

    mounted() {

      if (this.$props.preview) {
        this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

        this.$el.classList.add('preview');
      }

      this.animateValue(this.$refs.obj, parseInt(this.internal_config.init), parseInt(this.internal_config.finish), parseInt(this.internal_config.timer));

      let objIds = [];
      $('[id]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] == this && parseInt(this.id))
          objIds.push(this.id);
      });

      if (objIds.includes(this.id)) {
        this.id = Date.now() + parseInt(Math.random() * 10000);
      }

      this.$root.$on('setConfigElement', (id, obj) => {
        if (this.id == id) {
          this.config = obj;
          this.internal_config = obj;
        }
      });
      this.$refs.resourcesData.setValuesData(this);
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@media (max-width: 800px) {
  .progress {
    width: auto !important;
  }
}

[data-device="tablet"] .progress,
[data-device="mobile"] .progress {
  width: auto !important;
}

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/CounterBar/CounterBar.vue